<template>
  <div id="invoice">
    <div class="row spaced">
      <h1>Invoices</h1>
      <i class="fas fa-plus newIcon" @click="$router.replace('newInvoice')"></i>
    </div>
    <div class="header">
      <div class="card">
        <h2>15</h2>
        <p class="subtle-p">Outstanding Invoices</p>
      </div>
      <div class="card">
        <h2>$18,540.33</h2>
        <p class="subtle-p">Total Due</p>
      </div>
      <div class="card">
        <h2>3</h2>
        <p class="subtle-p">Late Invoices</p>
      </div>
    </div>
    <div class="invoices collection">
      <div v-for="item in invoices" :key="item.id">
        <div class="card" @click="openInvoice(item.id)">
          <p>{{item.invoice_id}}</p>
          <p>{{item.client}}</p>
          <p>{{item.status}}</p>
          <p>{{item.amount_due}}</p>
          <p>{{item.due_date}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../main";
import firebase from "firebase";
export default {
  name: "InvoiceDashboard",
  data() {
    return {
      invoices: [],
      user: "",
    };
  },
  methods: {
    openInvoice: function (id) {
      console.log(id);
      this.$router.push("/" + id);
    },
  },
  firestore() {
    this.user = firebase.auth().currentUser.uid; // This won't work if team members is implemented. This will only work for a single account
    return {
      invoices: db.collection("invoices").where("user_id", "==", this.user),
    };
  },
};
</script>

<style lang="scss" scoped>
#invoice {
  h1 {
    text-align: left;
    margin: 0;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .newIcon {
    cursor: pointer;
    font-size: 1.5rem;
    transition: 0.1s;

    &:hover {
      color: #0cce6b;
    }
  }

  width: 100%;
}

.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 15px;

  .card {
    background: #ffffff;
    padding: 15px 25px;
    margin: 0 15px;
    width: 250px;
    text-align: left;
    position: relative;
    border-radius: 2px;

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }

    h2 {
      font-size: 1.5vw;
      margin: 0;
    }

    .subtle-p {
      font-size: 0.9rem;
      color: rgb(184, 184, 184);
      margin: 10px 0 0 0;
    }
  }
}

.invoices {
  .card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: #fff;
    margin: 10px 0;
    cursor: pointer;

    p {
      margin: 5px;
      width: 200px;
      padding: 10px;

      &:first-of-type {
        width: auto;
        margin-left: 0;
        text-align: left;
      }

      &:last-of-type {
        margin-right: 0;
        text-align: right;
      }
    }
  }
}
</style>